import { debug, george, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { amountToCurrencyString } from "types/amount";
import { ISigningResponse } from "types/signing";
import { safeWindowOpen } from "util/helpers";
import { SigningComponent } from "../../signing/views/SigningComponent";
import { GidSettingsStore } from "./GidSettingsStore";
import { history } from "stores/RouterStore";
import { GidSettingsRoutes } from "./GidSettingsRoutes";
import { pushRoute } from "stores/RouterFunctions";

type IProps = RouteComponentProps<{}> & {
    store: GidSettingsStore;
};

@observer
export class GidSettingsLimitSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store.signInfo}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                                <pr.SigningLabel>
                                    {ui.__("gidSettings.limit.summary.action.description")}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                            <george.ResponsiveSummaryElement label={ui.__("gidSettings.limit.summary.newLimit.label")}>
                                <pr.SigningLabel>
                                    {this.props.store.selectedLimitOption === "noLimit"
                                        ? ui.__("gidSettings.limit.summary.newLimit.noLimit")
                                        : amountToCurrencyString(this.props.store.newLimit)
                                    }
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                        </div>
                    </>

                }
                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    if (history.location.pathname.startsWith(`${GidSettingsRoutes.ONBOARDING_LIMIT}/`)) {
                        safeWindowOpen("ggo://success");
                    } else if (history.location.pathname.startsWith(`${GidSettingsRoutes.LIMIT}/`)) {
                        pushRoute(GidSettingsRoutes.LIMIT_SUCCESS);
                    }
                }}
                onError={(response: ISigningResponse) => {
                    debug.log("### signing error", response);
                    if (history.location.pathname.startsWith(`${GidSettingsRoutes.ONBOARDING_LIMIT}/`)) {
                        safeWindowOpen("ggo://error");
                    }
                }}
                onRetry={async () => {
                    await this.props.store.postLimitChange();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsLimitSigning.tsx